const PM_MANAGED_BY = {
  FARMER: { value: "FARMER", name: "Farmer" },
  SHRIMP_TALK: { value: "SHRIMP_TALK", name: "ShrimpTalk" },
};

class PondMother {
  constructor() {
    this._id = "";
    this.code = "";
    this.created_at = "";
    this.managed_by = "";
    this.modified = "";
    this.mode = "";
    this.pond_id = "";
    this.pond_mother_id = "";
    this.remaining_feed = 0;
    this.shrimp_talk_id = null;
    this.status = "";
    this.title = "";
    this.total_feed = 0;
    this.updated_at = "";
    this.user_id = "";
    this.isEditted = false;
    this.hasSelected = "";
    this.retain_previous_day_schedule = false;
    this.delete_future_schedules = false;
    this.midnight_sch_enable = false;
    this.settings = {
      kg_dispense_time_sec: undefined,
      mode: "",
    };
  }

  getPmManagerType(type) {
    try {
      return PM_MANAGED_BY[type];
    } catch (err) {
      console.error("PM_MANAGED_BY of " + type + " does not exist");
    }
  }

  castToPMObj(inputPMDetails) {
    if (inputPMDetails != null && typeof inputPMDetails !== "undefined") {
      Object.keys(inputPMDetails).forEach((key) => {
        if (key === "settings") {
          Object.keys(inputPMDetails.settings).forEach((innerKey) => {
            if (innerKey === "kg_dispense_time") {
              this.settings.kg_dispense_time_sec =
                inputPMDetails.settings[innerKey];
              return;
            }
            this.settings[innerKey] = inputPMDetails.settings[innerKey];
          });
          return;
        }
        this[key] = inputPMDetails[key];
      });
      if (!this.settings || !this.settings.kg_dispense_time_sec) {
        this.settings.kg_dispense_time_sec = "";
      }
      this.pond_mother_id = this._id;
    }
  }

  getPMPropertiesObj() {
    const propertyNameList = [
      "title",
      "pond_mother_id",
      "managed_by",
      "shrimp_talks_id",
      "status",
    ];
    const properties = {};
    propertyNameList.forEach((property) => {
      properties[property] = this[property];
    });
    return properties;
  }
}

export default PondMother;
